// import React from 'react'
// import { Card, Button, Dropdown } from 'react-bootstrap'
// import { ThreeDots, Envelope, PersonPlus } from 'react-bootstrap-icons'

// export function MemberCard({ member }) {
//   return (
//     <Card className="position-relative">
//       <Card.Body className="text-center">
//         <Dropdown className="position-absolute top-0 end-0 mt-2 me-2">
//           <Dropdown.Toggle as={CustomToggle}>
//             <ThreeDots />
//           </Dropdown.Toggle>
//           <Dropdown.Menu>
//             <Dropdown.Item href="#/action-1">View profile</Dropdown.Item>
//             <Dropdown.Item href="#/action-2">Remove member</Dropdown.Item>
//           </Dropdown.Menu>
//         </Dropdown>

//         <div className="position-relative d-inline-block mb-3">
//           <div className="rounded-circle bg-light d-flex align-items-center justify-content-center" style={{ width: '80px', height: '80px' }}>
//             {member.avatarUrl ? (
//               <img
//                 src={member.avatarUrl}
//                 alt={member.name}
//                 className="rounded-circle w-100 h-100 object-fit-cover"
//               />
//             ) : (
//               <span className="fs-3 text-secondary">{member.name.charAt(0)}</span>
//             )}
//           </div>
//           {member.isOnline && (
//             <div
//               className="position-absolute top-0 end-0 rounded-circle border border-2 border-white"
//               style={{ width: '12px', height: '12px', backgroundColor: '#28a745' }}
//             />
//           )}
//         </div>

//         <Card.Title>{member.name}</Card.Title>
//         <Card.Text className="text-muted small mb-3">
//           Joined {member.joinedDate} • {member.lastActive}
//         </Card.Text>

//         <div className="d-flex justify-content-center gap-2">
//           <Button variant="outline-secondary" size="sm">
//             <PersonPlus className="me-1" /> Add
//           </Button>
//           <Button variant="outline-secondary" size="sm">
//             <Envelope className="me-1" /> Message
//           </Button>
//         </div>
//       </Card.Body>
//     </Card>
//   )
// }

// // Custom toggle component to remove default button styling
// const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
//   <button
//     className="bg-transparent border-0"
//     ref={ref}
//     onClick={(e) => {
//       e.preventDefault();
//       onClick();
//     }}
//   >
//     {children}
//   </button>
// ));

import React, { useState } from 'react'
import { Card, Button, Dropdown, Row } from 'react-bootstrap'
import { ThreeDots, Envelope, PersonPlus } from 'react-bootstrap-icons'
import axios from 'axios'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'

export function MemberCard({ member }) {
  const [requestStatus, setRequestStatus] = useState(null) // Track request status
  const navigate = useNavigate()
  const sendFriendRequest = async (toUserId) => {
    const token = localStorage.getItem('jwttoken')

    if (!token) {
      Swal.fire('Error', 'User not authenticated', 'error')
      return
    }

    try {
      const response = await axios.post(
        'https://kaasbackend.vetrinahealthcare.com/socialapp/friend_requests/send/',
        { to_user_id: toUserId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      )

      setRequestStatus('pending') // Update button to "Request Sent"
      Swal.fire('Success', response.data.detail, 'success')
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setRequestStatus('pending') // Update button to "Request Sent"
        Swal.fire('Info', error.response.data.detail, 'info')
      } else {
        console.error('Error sending friend request:', error)
        Swal.fire('Error', 'Failed to send friend request', 'error')
      }
    }
  }

  const profilePic =
    member.profile_pic && member.profile_pic.trim() !== ''
      ? member.profile_pic
      : null

  const handleMessageClick = (recipient) => {
    navigate(`/textmessage/${recipient.user_id}`, {
      state: { name: recipient.full_name, user_id: recipient.user_id },
    })
  }
  return (
    <Row className='gy-4 gx-4'>
      <div key={member.id} className='d-flex justify-content-center'>
        <Card
          className='w-100 h-100 position-relative shadow border-0'
          style={{
            borderRadius: '16px',
            background: 'rgba(255, 255, 255, 0.8)',
            backdropFilter: 'blur(10px)',
          }}
        >
          {/* Dropdown Menu */}
          {/* <Dropdown className="position-absolute top-0 end-0 mt-2 me-2">
            <Dropdown.Toggle as={CustomToggle}>
              <ThreeDots size={22} />
            </Dropdown.Toggle>
            <Dropdown.Menu className="shadow-sm">
              <Dropdown.Item href="#/action-1">View Profile</Dropdown.Item>
              <Dropdown.Item href="#/action-2" className="text-danger">
                Remove Member
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown> */}

          <Card.Body className='text-center'>
            {/* Avatar Section */}
            <div className='position-relative d-inline-block mb-3'>
              <div
                className='rounded-circle bg-light d-flex align-items-center justify-content-center shadow-sm'
                style={{
                  width: '95px',
                  height: '95px',
                  overflow: 'hidden',
                  border: '4px solid #ddd',
                }}
              >
                {profilePic ? (
                  <img
                    src={profilePic}
                    alt='Profile'
                    className='rounded-circle w-100 h-100'
                    style={{ objectFit: 'cover' }}
                    referrerPolicy='no-referrer'
                  />
                ) : (
                  <span className='fs-3 text-secondary fw-bold'>
                    {member.first_name.charAt(0)}
                    {member.last_name.charAt(0)}
                  </span>
                )}
              </div>
            </div>

            {/* Member Name & Details */}
            <Card.Title className='fw-semibold text-dark'>
              {member.first_name} {member.last_name}
            </Card.Title>
            <Card.Text className='text-muted small'>
              Joined <strong>{member.joined_date}</strong> • Last Active:{' '}
              <strong>{member.last_active}</strong>
            </Card.Text>

            {/* Action Buttons */}
            <div className='d-flex justify-content-center gap-3 mt-3'>
              {member.is_friends ? (
                <Button variant='success' disabled>
                  ✅ Connected
                </Button>
              ) : (
                <Button
                  style={{ backgroundColor: '#B54EA5' }} // Custom color
                  onClick={() => sendFriendRequest(member.user_id)}
                  disabled={requestStatus === 'pending'}
                >
                  <PersonPlus className='me-1' />
                  {requestStatus === 'pending' ? 'Request Sent' : 'Add Friend'}
                </Button>
              )}
              <Button
                variant='outline-secondary'
                size='sm'
                className='d-flex align-items-center px-3 shadow-sm'
                onClick={() => handleMessageClick(member)}
              >
                <Envelope className='me-1' /> Message
              </Button>
            </div>
          </Card.Body>
        </Card>
      </div>
    </Row>
  )
}

// Custom toggle component to remove default button styling
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <button
    className='bg-transparent border-0'
    ref={ref}
    onClick={(e) => {
      e.preventDefault()
      onClick()
    }}
  >
    {children}
  </button>
))
